import routes from './routes'
// lib组件中的国际化
import jurisdic from './lib/jurisdic'
import select from './lib/select'
import table from './lib/table'
// 页面中的国际化
import routesLib from './routes/index'
// 页面固定选择的select的options
import options from './options'
// 时间表达式国际化
import cron from './lib/cron'

export default {
  routes,
  // lib组件中的国际化
  jurisdic,
  select,
  table,
  cron,
  // 页面中的国际化
  ...routesLib,
  // options选项国际化
  options,
  // 首页
  dashboard: {
    helloMorning: '上午好',
    helloNoon: '中午好',
    helloEvening: '晚上好',
    welcome: '欢迎使用智联云采',
    welcomeSub: '欢迎使用智联云采供应链管理平台',
    today: '今天',
    date: '{y}年{m}月{d}日',
    newsTip: '【新闻】',
    newsDate: '{m}月{d}日',
    week: ['星期天', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
    feedback: '建议反馈',
    feedbackTip: '任何关于产品的建议和意见您都可以告诉我们…',
    submit: '提交',
    tip: '提示',
    submitTip: '提交成功，感谢您的反馈',
    todo: '待办事项',
    alarm: '告警信息',
    commonly: '常用模块',
    allOrder: '总订单',
    bulletin: '新闻通告',
    analysis: '数据分析',
    proportion: '供应商占比',
    turnover: '供应商交易额（万元）',
    growth: '订单增长率',
    notAfter: '授权到期时间：',
    authorization: '授权管理',
    product: '产品名称',
    productName: '智联云采ZHILINK',
    version: '产品版本',
    versionNo: 'V1.1',
    brand: 'ERP品牌',
    institutionalCap: '机构上限',
    orderVolume: '订单量',
    all: '全部',
    seeAll: '查看全部',
    general: '一般采购',
    outsourcing: '委外采购',
    month: '月',
    orderDeliveryRate: '订单答交率',
    orderCompletionRate: '交货达成率',
    passRatePur: '订单合格率',
    todoList: ['待收货订单', '待对账费用', '待核对发票', '待抛转对账', '待评估供应商', '未审核扣款', '未审核合同', '待审批报价', '未核价报价'],
    supplierTodoList: ['待确认订单', '待发货订单', '未确认发货', '未确认对账', '待录发票', '未确认扣款', '待报价询价', '被议价报价'],
    alarmList: ['逾期订单', '预警订单', '失效合同', '预警合同', '质量扣款', '退货', '验退', '失效资质', '预警资质'],
    orderList: ['总订单', '今日新订单', '逾期订单', '送货在途订单'],
    analysisType: ['全部', '1个月', '3个月', '1年'],
    qualified: '合格',
    failed: '不合格'
  },
  // 其他的常用国际化
  common: {
    about: '关于智互联',
    link: '联系我们',
    copyright: '著作权与商标声明',
    legalNotices: '法律声明',
    terms: '服务条款',
    privacy: '隐私政策',
    navigation: '网址导航',
    company: '© Copyright 2019 智互联（深圳）科技有限公司版权所有',
    recentActions: '最近操作',
    allFunctions: '全部功能',
    btnTypes: ['操作表', '历史表'],
    select: '请选择',
    selectAll: '全选',
    input: '请输入',
    keywordInput: '请输入关键字',
    listRequired: '请添加数据',
    userSettings: '设置',
    userInfo: '资料',
    userLogout: '退出',
    supplier: '供应商',
    purchasers: '采购商',
    submit: '保 存',
    submitAndAdd: '保存并新增',
    cancel: '取 消',
    clear: '清 空',
    confirm: '确 认',
    ok: '同 意',
    refuse: '拒 绝',
    confirmSchedule: '确认调度',
    noTabs: '暂无标签',
    advancedSearch: '高级搜索',
    search: '查 询',
    reset: '重 置',
    addToFavoriteTagsBtn: '添加到常用标签',
    retract: '收 起',
    add: '新增',
    modify: '编辑',
    remove: '删除',
    split: '拆分',
    selectDateTitle: '选择时间范围',
    selectDate: ['开始时间', '截止时间'],
    dateTips: ['开始时间不能大于截止时间', '截止时间不能小于开始时间'],
    remarks: '备注',
    detail: '详情',
    mobile: '手机号',
    phone: '电话号码',
    email: '邮箱',
    validMobile: '请输入正确手机号码',
    validPhone: '请输入正确电话号码',
    validEmail: '请输入正确邮箱号',
    checked: '已勾选',
    row: '行',
    onlyOneFileTip: '只能上传一个文件',
    settingTitle: '系统设置',
    columnSetting: '列设置',
    columnName: '列名',
    showOrHide: '显示/隐藏',
    columnFrozen: '列冻结',
    columnFrozenLeft: '左冻结',
    columnFrozenRight: '右冻结',
    columnSort: '排序',
    screeningConditions: '筛选条件',
    i18nListTitle: '国际化栏位',
    i18nListTip: '以下栏位名称需做国际化，请完成所有语言的输入',
    i18nListRule: '请输入完整',
    tagName: '标签名称',
    tagTitle: '常用标签',
    commonTags: '常用标签',
    required: '请输入',
    tooLongTip: '请输入100个字符以内',
    fixedInSix: '请保留6位以内小数',
    tooLongNumber: '请输入20位以内数字',
    empty: '暂无数据',
    register: '注册',
    forgetPassword: '忘记密码',
    supplierPlatform: '供应商平台',
    getMobileCode: '获取验证码',
    regetMobileCode: '重获验证码',
    datePlaceholder: 'yyyy-MM-dd',
    confirmPublish: '确认发布',
    draft: '暂存草稿',
    dragTitleWarning: '鼠标按住拖动可改变顺序',
    allFixed: '全部固定',
    allUnFixed: '全部取消',
    accept: '受理',
    checkAcceptance: '查看受理',
    importTemplate: '导入模板',
    previewFile: '查看附件',
    file: '附件',
    commit: '提交'
  },
  formTitle: {
    baseInfo: '基础信息',
    extendInfo: '拓展信息',
    controlInfo: '控制信息',
    supplierSetting: '供应商设置',
    paraInfo: '参数信息',
    contactInfo: '联系方式',
    othersInfo: '其他信息',
    barcodeInfo: '条码元素',
    workInfo: '工作资料',
    passwordInfo: '登录设置',
    customInfo: '扩展信息'
  },
  message: {
    success: '操作成功',
    delete: '是否确定删除？',
    nullify: '是否确定作废？',
    email: '请输入正确的邮箱地址'
  },
  login: {
    hi: 'hi，您好',
    words: '欢迎登录供应商管理平台',
    name: '账号',
    requiredName: '请输入账号',
    password: '密码',
    requiredPassword: '请输入密码',
    signIn: '登录',
    title: '系统登录',
    logIn: '登录',
    confirmTip: '您已注销，您可以取消以停留在此页，或重新登录',
    confirmLogOut: '确认注销',
    confirmBtn1: '重新登录',
    confirmBtn2: '取消',
    copyright: '© Copyright 2020 智互联（深圳）科技有限公司版权所有',
    changePassword: '修改密码',
    titleDesc: '欢迎登录 WMS数据管理平台',
    helloMorning: '上午好，崭新的一天又开始了',
    helloNoon: '下午好，活力满满工作也要加油哦',
    helloEvening: '晚上好，忙碌的同时也要注意休息',
    username: '姓名'
  },
  404: {
    oops: '抱歉!',
    headline: '当前页面不存在...',
    info: '请检查您输入的网址是否正确，或点击下面的按钮返回首页。',
    btn: '返回首页'
  },
  forgetpass: {
    findpass: '找回密码',
    step0tip: '正在为您重置密码,请选择找回方式：',
    useEmail: '通过邮箱找回密码',
    usePhone: '通过手机找回密码',
    step0foots: ['如果以上两种方式均无法解决，请', '联系客服', '找回'],
    steps: ['填写资料', '验证身份', '设置新密码', '完成'],
    next: '下一步',
    back: '返回',
    loginName: '账号',
    requiredLoginName: '请输入账号',
    email: '邮箱',
    requiredEmail: '请输入邮箱',
    verificationCode: '验证码',
    requiredVerificationCode: '请输入验证码',
    realVerificationCode: '验证码不正确',
    email2tips: ['验证邮件已发送到', '请立即登录邮箱验证吧！', '若未收到邮件，请将', 'postmaster@xmail.zhilink.com', '添加到白名单。'],
    mobile: '手机',
    requiredMobile: '请输入手机号',
    phone2tips: ['您正在为账号', '找回密码'],
    yanzheng: '验证',
    requiredYanzheng: '请输入短信验证码',
    newPassword: '新密码',
    surePassword: '确定密码',
    requiredNewPassword: '请输入新密码',
    requiredSurePassword: '请输入确定密码',
    diffPassword: '两次密码输入不一致',
    step4tips: ['您已成功设置密码，请使用新密码登录', '立即登录']
  },
  tableCommon: {
    setUse: ['停用', '启用'],
    whetherGoOn: '是否进行',
    operation: '操作',
    remove: '删除',
    modify: '编辑',
    sort: '排序',
    confirm: '确 定',
    reason: '请输入驳回原因',
    reason2: '驳回原因',
    billNo: '单据编号',
    invoiceNumber: '发票号',
    void: '作废',
    toss: '抛转',
    cancelTheToss: '取消抛转',
    viewReason: '查看驳回原因',
    check: '审核',
    schedule: '调度',
    commodityManagement: '商品管理',
    Inquiry: '询报价',
    performance: '绩效',
    relationshipManagement: '关系管理',
    input: '录入',
    answer: '答交',
    wherefore: '原因',
    column: {
      adddate: '创建时间',
      addby: '创建人',
      upddate: '更新时间',
      updby: '更新人'
    }
  },
  register: {
    title: '注册 Step {s}',
    invitationCode: '邀请码',
    loginName: '账号',
    name: '姓名',
    mobile: '手机号',
    password: '设置密码',
    rePassword: '确认密码',
    invitationEmail: '邮箱',
    mailVerificationCode: '邮箱验证码',
    verificationCode: '验证码',
    getEmailCode: '获取验证码',
    resetGet: '重新获取',
    getLoading: '正在发送...',
    errorVerificationCode: '验证码错误',
    agreement: '我已认真阅读，并同意',
    requiredAgreement: '请先确认协议',
    tapsTitle: ['注册新企业', '个人加入公司'],
    fileList: '工商营业执照',
    classifyNo: '供应商分类名称',
    officeFullName: '企业名称',
    creditCode: '统一社会信用代码',
    legalRepresentative: '法定代表人',
    btns: ['完成', '跳过']
  },
  commonDialog: {
    placeHolder: '供应商名称/供应商类别',
    placeHolder1: '物料名称/物料品类名称',
    placeHolder2: '物料类别名称/物料类别编码',
    placeHolder3: '分类编码/分类名称',
    supplier: '供应商名称',
    selectSupplier: '选择供应商',
    supplierNo: '供应商编码',
    supplierName: '供应商名称',
    classifyNoList: '供应商类别',
    supplierGroup: '供应商组',
    supplierStatusName: '供应商状态',
    city: '城市',
    selectGoodsDialog: '选择物料',
    itemNo: '物料编码',
    itemName: '物料名称',
    groupNos: '物料类别',
    purchaseUnitNo: '采购中心编码',
    purchaseUnitName: '采购中心',
    itemSpec: '物料规格',
    groupNo: '物料品类编号',
    groupName: '物料品类名称',
    unitNo: '单位',
    checkSupplier: '查看供应商',
    checkItem: '查看物料',
    checkItemType: '查看物料类别',
    chooseType: '选择物料类别',
    remarks: '备注',
    chooseSupplierType: '选择供应商类别',
    classifyNo: '分类编码',
    classifyName: '分类名称'
  }
}
